import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';

import * as navigationActions from '../navigation.actions';

const OverflowFixer = styled.div`
  position: fixed;
  z-index: 1001;
  width: 100vw;
`;

const StyledHamburger = styled.a`
  position: absolute;
  width: 3.625rem;
  height: 3.625rem;
  top: 2.9375rem;
  right: 9rem;

  ${styles.media.tablet`
    width: 5.125rem;
    height: 5.125rem;
    right: 11rem;
  `} ${styles.media.phone`
    width: 3.625rem;
    height: 3.625rem;
    top: 2.3125rem;
    right: 7.25rem;
  `} background-color: ${styles.color.WHITE};
  border-radius: 100%;
  z-index: 1001;
  box-shadow: rgba(59, 60, 67, 0.2) 0px 0.625rem 1.5rem;

  transition-property: box-shadow, opacity;
  transition-duration: 0.25s, .5s;
  transition-timing-function: ${styles.easing.inOutQuad};
  cursor: pointer;

  .current-input-mouse &:hover,
  .current-input-touch &:active {
    box-shadow: rgba(59, 60, 67, 0.2) 0px 1.25rem 3rem;

    svg {
      color: ${styles.color.SLATE};
    }
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    color: ${styles.color.ORANGE};

    fill: none;
    stroke: currentColor;
    stroke-width: 2px;
    transform-origin: 50% 50%;
    transition: color 0.35s ${styles.easing.inOutBack};
  }

  &.open {
    opacity: 0;
  }
`;

class BackButton extends Component {
  static propTypes = {
    navigate: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    url: PropTypes.string,
  };

  onClick = e => {
    const { navigate, url } = this.props;
    navigate(`/${url}`, true);
  };

  render() {
    const { isOpen, url } = this.props;
    if (!url) return null;
    const className = classnames({
      open: isOpen,
    });

    return (
      <OverflowFixer>
        <StyledHamburger onClick={this.onClick} className={className}>
          <svg viewBox="0 0 72 72">
            <line x1="23.5" y1="36" x2="48.5" y2="36" />
            <polyline points="36.5,25 23.5,36 36.5,47" />
          </svg>
        </StyledHamburger>
      </OverflowFixer>
    );
  }
}

const mapStateToProps = (state, { location: { pathname } }) => {
  const pathSplit = pathname.split('/').filter(segment => segment !== '');
  let url;
  if (pathSplit.length > 1) {
    url = pathSplit.slice(0, pathSplit.length - 1).join('/');
  }

  return {
    url,
  };
};

export default withRouter(
  connect(mapStateToProps, navigationActions)(BackButton)
);



// WEBPACK FOOTER //
// ./src/modules/navigation/components/BackButton.js